
import {pujamodel} from "./Puja.js";
import {donationmodel} from "./Donation.js";
import {bookmodel} from "./Book.js";



export default function getFeatureMiddleware() {
  return [
    ...pujamodel,
    ...donationmodel,
    ...bookmodel
  ]
}